require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/core-js/modules/es6.array.species.js
// module id = 299
// module chunks = 0